import { computed } from "vue";
import { store } from "../store";

export const isSuperAdmin = (user) => user?.role?.name === 'super_admin'

export const isRoleTypeAdmin = (user) => ['super_admin', 'sales_admin', 'sales_reps', 'quote_approver'].includes(user?.role?.name);

export const canAccessSpeq = (user = null ) => {
  const authUser = computed(() => store.getters.user);
  const currentLocation = computed(() => store.getters.currentLocation);
  const isSelectedLocationSpeq = parseInt(localStorage.getItem('is_selected_location_speq'));

  const currentUser = user ?? authUser;

  return isRoleTypeAdmin(currentUser.value) || isSelectedLocationSpeq || currentLocation.value?.is_speq;
}